const strize = require('../strize')

module.exports = {
  title: 'Eval PP ADMIN',
  imgs: {
    root: '../../imagesPP'
  },
  home: '/simuplayers',
  features: {
    elearning: false,
    simu: true,
    eval: false
  },
  bucket: {
    player: {
      bucket: strize(''),
      region: strize('')
    },
    editor: {
      bucket: strize(''),
      region: strize(''),
      key: strize(''),
      secret: strize('')
    }
  },
  colors: {
    main: '#000000',
    bgSideBar: '#024179',
    bgCell: '#999999',
    ActionMail: '#dadada'
  },
  layouts: {
  }
}
